<template>
    <div :class="['edit-upload', title === 'Exterior' && 'border-none']">
        <h3>{{label}}</h3>
        <p class="title">{{title}}</p>
        <div class="img_box" v-for="(item, index) in displayImgList" :key="index">
            <div :data-img="item">
                <div class="photo-wrap" v-show="isSelfieImg(item)">
                  <img class="img" :src="item">
                  <div class="photo-btn replace" @click="uploadClick">
                    <img src="@/assets/pc/upload-outline@2x.png" />
                    <span>Replace Photo</span>
                  </div>
                </div>
                <div class="file" @click="openFile(item)" v-show="isSelfiePdf(item)">
                    <img class="success-icon" src="@/assets/pc/success-filled.png" />
                    <span>{{ getFileName(item) }}</span>
                    <img 
                        v-if="addRemoveFlag && imgUploadData.length > 1 && (ekycStatus === 0 || ekycStatus === 4) || (isSelfie && item.endsWith('.pdf'))"
                        class="close-icon" 
                        src="@/assets/pc/file-cancel-icon.png" 
                        @click.stop="removeList(index)" 
                    />
                </div>
                <div v-show="!isSelfieImg(item) && !isSelfiePdf(item)" class="photo_box">
                    <el-upload
                        :id="`fileUploadId${uploadNumber}`"
                        class="upload-content"
                        action=""
                        accept=".jpg,.jpeg,.png,.pdf"
                        :show-file-list="false"
                        :http-request="(e) => uploadImgSuccess(e, 'simple')"
                        :before-upload="beforeImgUpload"
                    >
                        <div class="photo-content">
                            <p><img src="@/assets/pc/upload-outline@2x.png" />Upload Photo</p>
                        </div>
                    </el-upload>
                </div>
            </div>
        </div>
        <div v-if="imgUploadData.length > 10 && !isShowMoreFile" class="show-more" @click="showMorefile">Show More ({{imgUploadData.length - 10}})</div>
        <div :class="['btn-pc-upload', isSelfie && 'gray-wrap']">
            <!-- 多张上传 -->
            <div  v-if="!isSelfie && addRemoveFlag && (ekycStatus === 0 || ekycStatus === 4) && imgUploadData.length < exceedNumber" class="list-content">
              <span class="num">{{imgUploadData.length}} out of {{exceedNumber}}</span>
              <el-upload
                  action=""
                  accept=".jpg,.jpeg,.png,.pdf"
                  :show-file-list="false"
                  :multiple="true"
                  :http-request="(e) => uploadImgSuccess(e, 'multiple', onceUploadNumber, exceedNumber, imgUploadData)"
                  :before-upload="beforeImgUpload"
              >
                  <div class="photo-btn add" @click="clearOnceUploadTime">
                      <span>+ Add Another File</span>
                  </div>
              </el-upload>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditUpload",
    components: {},
    props: {
        label: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        imgValue: {
            type: [String, Array],
            default: '#'
        },
        ekycStatus: {
            type: [Number, String],
            default: 0
        },
        // 当前页面上传组件脚标
        uploadNumber: {
          type: Number,
          default: 0
        },
        // 单次最大上传数 5
        onceUploadNumber: {
          type: Number,
          default: 5
        },
        // 最大上传文件数
        exceedNumber: {
          type: Number,
          default: 5
        },
    },
    data() {
        return{
            imgUploadData: [],
            imgData: '',
            imgList: [],
            index: '',
            pdfSrc: '',
            showDialog: false,
            addRemoveFlag: false,
            onceUploadTime: 0,
            uploadingNumber: 0,
            isShowMoreFile: false,
        }
    },
    created() {
        this.addRemoveFlag = ['Photo of SEC Certificate', 'Photo of DTI Certificate', 'Interior', 'Exterior'].includes(this.title)
        this.getImgList();
    },
    computed:{
        isSelfie() {
          return this.title === 'Selfie with ID';
        },
        displayImgList() {
          return this.isShowMoreFile ? this.imgUploadData : this.imgUploadData.slice(0, 10);
        },
        // Selfie上传了图片判断
        isSelfieImg() {
          return (item) => {
            const isSelfie = this.title === 'Selfie with ID';
            return item && item != '' && isSelfie && !item.endsWith('.pdf')
          }
        },
        // Selfie上传了pdf判断
        isSelfiePdf() {
          return (item) => {
            const isSelfie = this.title === 'Selfie with ID';
            return item && item != '' && (isSelfie && item.endsWith('.pdf') || !isSelfie)
          }
        }
    },
    methods: {
        showMorefile() {
          this.isShowMoreFile = true;
        },
        clearOnceUploadTime() {
            this.onceUploadTime = 0;
        },
        closeDialog() {
            this.showDialog = false;
        },
        removeList(index) {
            this.$emit('removeData', {name: this.title, index})
        },
        getImgList() {
          if(Array.isArray(this.imgValue)) {
            this.imgUploadData = this.imgValue;
          } else if(this.imgValue) {
            this.imgUploadData = this.imgValue ? this.imgValue.split(',') : [];
          } else {
            this.imgUploadData = [this.imgValue];
          }
        },
        // 自动触发上传
        uploadClick() {
          const element2 = document.querySelector(`#fileUploadId${this.uploadNumber} .el-upload__input`);
          element2 && element2.click();
        }
    },
    watch: {
        imgValue() {
          this.getImgList();
        },
        imgData() {
          if(this.title == 'Selfie with ID') {
            this.$emit('uploadData', {name: this.title, data: this.imgData})
          }
        },
        imgList() {
          let data = null;
          const arr = [...this.imgList];
          const imgUploadData = [...this.imgUploadData, arr.pop()];
          this.imgUploadData = imgUploadData;
          if(['Photo of SEC Certificate', 'Photo of DTI Certificate'].includes(this.title)) {
            data = imgUploadData.join(',');
          }
          if(['Interior', 'Exterior'].includes(this.title)) {
            data = imgUploadData;
          }
          this.$emit('uploadData', {name: this.title, data})
        }
    }
}
</script>

<style lang="scss" scoped>
.edit-upload {
    margin-bottom: 32px;
    border-bottom: 1px solid #E8E8E8;
    padding-bottom: 24px;
    &:last-child, &.border-none {
      border-bottom: none;
    }
    h3,p {
        width: 100%;
    }
    h3 {
        font: normal normal normal 20px/24px Nunito-bold;
        letter-spacing: 0px;
        color: #2E2E2E;
        margin-bottom: 16px;
        height: 24px;
    }
    .title{
        font: normal normal normal 16px/24px Nunito;
        letter-spacing: 0px;
        color: #2E2E2E;
        margin-bottom: 12px;
        height: 24px;
    }
    .file {
      width: 100%;
      display: flex;
      font: normal normal normal 14px/24px Nunito-bold;
      background-color: #F6F6F6;
      padding: 12px 16px 12px 12px;
      align-items: center;
      color: #2E2E2E;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      word-break: break-word;
      margin-bottom: 8px;
      .success-icon {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
      span {
        flex: 1;
      }
      .close-icon {
        width: 30px;
        height: 30px;
        margin-left: 10px;
      }
    }
    .photo_box {
      background-color: #E5F5FF;
      border-radius: 8px;
      overflow: hidden;
      margin-top: 10px;
      & > div {
        text-align: center;
      }
      .photo-content {
        width: 371px;
        height: 218px;
        border-radius: 8px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        img {
            width: 302px;
            height: 193px;
        }
        p {
          margin: 0 auto;
          width: 195px;
          color: #0072D8;
          font: normal normal normal 16px/48px Nunito-bold;
          border-radius: 8px;
          border: 2px solid #0072D8;
          text-align: left;
          padding-left: 24px;
          box-sizing: border-box;
          img {
            width: 32px;
            height: 32px;
            vertical-align: middle;
            margin-right: 8px;
            margin-top: -5px;
          }
        }
      }
    }
    .show-more {
      border-radius: 6px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font: normal normal normal 14px/24px Nunito-bold;
      color: #0072D8;
      cursor: pointer;
      margin-bottom: 8px;
      background-color: #E5F1FF;
      padding: 8px 0;
      box-sizing: border-box;
    }
    .no_img{
      box-sizing: content-box;
      width: 100%;
      height: 230px;
      border-radius: 8px;
      .img {
        display: block;
        width: 100% !important;
        height: 230px;
        border-radius: 0;
        overflow: hidden;
        font-size: 0;
      }
    }
    .img_box {
        .img {
          display: block;
          width: 100% !important;
          height: 230px;
          overflow: hidden;
          font-size: 0;
        }
    }
    .btn {
        padding-left: 90px;
    }
    .btn-pc-upload{
        width: 100%;
        >div{
            width: 100%;
            margin-bottom: 0;
            ::v-deep .el-upload{
              width: 100%;
            }
        }
        &.gray-wrap {
            display: flex;
            justify-content: center;
            background-color: #F6F6F6;
            padding: 0 16px;
            box-sizing: border-box;
            border-radius: 0 0 8px 8px;
            >div{
                margin-bottom: 16px;
            }
        }
    }
    .photo-wrap {
      background-color: #F6F6F6;
      padding: 16px;
      border-radius: 8px;
    }
    .photo-btn {
        // width: 366px;
        height: 34px;
        overflow: hidden;
        cursor: pointer;
        span {
            float: right;
            font: normal normal normal 16px/22px Nunito-bold;
            color: #0072D8;
            cursor: pointer;
            text-decoration: underline;
        }
        &.replace {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 48px;
            padding: 0;
            border: 2px solid #0072D8;
            border-radius: 8px;
            background-color: #ffffff;
            margin-top: 16px;
            img {
              width: 20px;
              height: 20px;
              margin-right: 8px;
              margin-top: -2px;
            }
            span {
                text-decoration: none;
            }
        }
    }
    .add {
        margin: 0;
        margin-top: 10px;
        padding: 0;
        font: normal normal normal 16px/24px Nunito-bold;
        text-decoration: underline;
        color: #0072D8;
    }
    .list-content{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 4px 0 16px;
      .num{
        width: 50%;
        font-size: 16px;
        color: #656565;
      }
    }
}
</style>